import { Spin } from 'antd';
import { cn } from '../../../utils/string/cn.utils';

const ButtonSecondarySmall = ({
  type = 'button',
  id,
  title,
  disabled,
  style,
  preIcon,
  posIcon,
  onClick,
  loading = false,
  ...props
}) => {
  return (
    <button
      type={type}
      id={id}
      {...props}
      className={cn(
        'inline-flex justify-center items-center bg-fills-white border-[1px] border-solid border-outline-brand-primary text-primary-primary hover:bg-primary-primaryFill disabled:bg-fills-disable disabled:border-outline-default-disable disabled:text-black-low',
        'h-[24px] py-[4px] px-[8px] gap-[4px] text-body-small font-semibold rounded-[6px]',
        props.className?.includes('active') && 'bg-primary-primaryVarient2',
        props.className
      )}
      disabled={disabled}
      style={{
        ...(props?.style ?? {}),
        ...{
          paddingRight: `${preIcon ? '6px' : undefined}`,
          paddingLeft: `${posIcon ? '6px' : undefined}`,
        },
      }}
      onClick={onClick}
    >
      {posIcon && (
        <div className="w-[14px] h-[14px] flex items-center text-primary-primary disabled:text-black-low">
          {posIcon}
        </div>
      )}
      <span className="truncate text-primary-primary disabled:text-black-low">
        {title}
      </span>
      <Spin spinning={loading} size={16} />
      {preIcon && (
        <div className="w-[14px] h-[14px] flex items-center text-primary-primary disabled:text-black-low">
          {preIcon}
        </div>
      )}
    </button>
  );
};

export default ButtonSecondarySmall;
